<form class="flex-column gap-standard " *ngIf="mainFormGroupSubject | async" [formGroup]="mainFormGroupSubject | async">

  
  <div class="col-width-2">
    <ss-text-form-control id="title-field" dataField="description" formControlName="description"></ss-text-form-control>

    <div class="flex-row gap-standard">
      <ss-date-form-control class="flex-1" dataField="validTill" formControlName="validTill"></ss-date-form-control>
  
      <ss-select-form-control class="flex-1" dataField="processSharingType" formControlName="processSharingType"></ss-select-form-control>
    </div>
  </div>
  
  

  <ss-text-area-form-control 
    [minRows]="8" 
    [maxRows]="15" 
    dataField="note"
    formControlName="note"
  ></ss-text-area-form-control>

</form>